import type { StaticLayerPayload } from "@config";
import { NarratorLibrary, NarratorPdf } from "@library-combos/narrator";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: NarratorLibrary,
  pdf: NarratorPdf,
};

export const Narrator = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
